import Handlebars from '../../libraries/handlebars';

export default function() {
    Handlebars.registerHelper("checkSalePrice", function (price, salePrice) {
        return salePrice > 0 ? salePrice : price;
    });

    Handlebars.registerHelper("conditional", function (isChecked, productCount) {
        return isChecked || productCount;
    });

    Handlebars.registerHelper("isEmpty", function (str1, str2) {
        return !str1 || str1 === "" ? str2 : str1;
    });

    Handlebars.registerHelper("join", function (values, delimeter) {
        return values.join(delimeter);
    });

    Handlebars.registerHelper("moreThan", function (value1, value2) {
        return value1 > value2;
    });
}